import state from './search-state';
import mutations from './search-mutations';
import actions from './search-actions';
import getters from './search-getters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
